import { render, staticRenderFns } from "./AttachFileOut.vue?vue&type=template&id=60a1149c&scoped=true"
import script from "./AttachFileOut.vue?vue&type=script&lang=js"
export * from "./AttachFileOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a1149c",
  null
  
)

export default component.exports